<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-sell') && ['draft','sent','declined','accepted'].includes(quote.status)) {
      <ion-item button="true" (click)="openQuote()">
        <ion-label><fa-icon [icon]="['fal', 'folder-open']" size="lg" [fixedWidth]="true"></fa-icon>Open</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-sell') && permissionService.isPermitted('pos-quotes-duplicate-quote')) {
      <ion-item button="true" (click)="duplicateQuote()">
        <ion-label><fa-icon [icon]="['fal', 'copy']" size="lg" [fixedWidth]="true"></fa-icon>Duplicate</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-email-quote') && quote.items && ['draft','sent','declined','accepted'].includes(quote.status)) {
      <ion-item button="true" (click)="presentQuoteEmailModal()">
        <ion-label><fa-icon [icon]="['fal', 'envelope']" size="lg" [fixedWidth]="true"></fa-icon>Email</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-print-quote') && quote.items && ['draft','sent','declined','accepted'].includes(quote.status) &&printer_paper_sizes && printer_paper_sizes.length > 0) {
      @if (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" id="print_invoice" detail="true">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print</ion-label>
        </ion-item>
        <ion-popover trigger="print_invoice" [dismissOnSelect]="true" side="start">
          <ng-template>
            <ion-content>
              <ion-list lines="full">
                @if (printer_paper_sizes.includes('a4')) {
                  <ion-item button="true" (click)="printQuote('a4')">
                    <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                  </ion-item>
                }
                @if (printer_paper_sizes.includes('thermal')) {
                  <ion-item button="true" (click)="printQuote('thermal')">
                    <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                  </ion-item>
                }
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      }
      @if (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" (click)="printQuote('a4')">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print</ion-label>
        </ion-item>
      }
      @if (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
        <ion-item button="true" (click)="printQuote('thermal')">
          <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print</ion-label>
        </ion-item>
      }
    }

    @if (permissionService.isPermitted('pos-quotes-edit-quote') && quote.archived == false) {
      <ion-item button="true" (click)="archiveQuote()">
        <ion-label><fa-icon [icon]="['fal', 'archive']" size="lg" [fixedWidth]="true"></fa-icon>Archive</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-edit-quote') && quote.archived == true) {
      <ion-item button="true" (click)="unarchiveQuote()">
        <ion-label><fa-icon [icon]="['fal', 'archive']" size="lg" [fixedWidth]="true"></fa-icon>Unarchive</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-edit-quote') && quote.items && quote.status == 'draft') {
      <ion-item button="true" (click)="presentQuoteMarkAsSentModal()">
        <ion-label><fa-icon [icon]="['fal', 'check']" size="lg" [fixedWidth]="true"></fa-icon>Mark as sent</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-decline-quote') && quote.items && quote.status == 'sent') {
      <ion-item button="true" (click)="presentQuoteMarkAsDeclinedModal()">
        <ion-label><fa-icon [icon]="['fal', 'times']" size="lg" [fixedWidth]="true"></fa-icon>Mark as declined</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-accept-quote') && quote.items && ['sent','declined'].includes(quote.status)) {
      <ion-item button="true" (click)="presentQuoteMarkAsAcceptedModal()">
        <ion-label><fa-icon [icon]="['fal', 'check']" size="lg" [fixedWidth]="true"></fa-icon>Mark as accepted</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-edit-quote') && quote.items && ['sent','declined','accepted'].includes(quote.status)) {
      <ion-item button="true" (click)="presentQuoteCancelModal()">
        <ion-label><fa-icon [icon]="['fal', 'ban']" size="lg" [fixedWidth]="true"></fa-icon>Cancel</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-edit-quote')) {
      <ion-item button="true" (click)="presentQuoteEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-quotes-delete-quote')) {
      <ion-item button="true" (click)="deleteQuote()">
        <ion-label><fa-icon [icon]="['fal', 'trash-alt']" size="lg" [fixedWidth]="true"></fa-icon>Delete</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
